module.exports = __webpack_public_path__ + "img/cart2.3abdee4a.svg";